import React from 'react';
import { Box, Flex, Text, Button, VStack, Spinner } from '@chakra-ui/react';
import { BsPlus } from 'react-icons/bs';
import { ConversationItem } from './ConversationItem';

export const ConversationsList = ({
  conversations,
  selectedId,
  onSelect,
  onNewConversation,
  isLoading,
}) => {
  return (
    <Box
      w="280px"
      flexShrink={0}
      h="calc(100vh - 160px)"
      bg="white"
      borderRightWidth="1px"
      borderRightColor="gray.100"
      display="flex"
      flexDirection="column"
    >
      {/* Header */}
      <Flex
        px={3}
        py={3}
        alignItems="center"
        justifyContent="space-between"
        borderBottomWidth="1px"
        borderBottomColor="gray.100"
      >
        <Text fontSize="sm" fontWeight="600" color="gray.700" letterSpacing="0.01em">
          Conversations
        </Text>
        <Button
          size="xs"
          h={7}
          px={2.5}
          bg="var(--brand-primary)"
          color="white"
          fontWeight="500"
          fontSize="xs"
          borderRadius="md"
          _hover={{ bg: 'var(--brand-primary-hover)' }}
          _active={{ bg: 'var(--brand-primary-active)' }}
          onClick={onNewConversation}
          leftIcon={<BsPlus />}
        >
          New
        </Button>
      </Flex>

      {/* List */}
      <VStack
        px={2}
        py={2}
        gap={0.5}
        overflowY="auto"
        flex={1}
        align="stretch"
        sx={{
          '&::-webkit-scrollbar': { width: '4px' },
          '&::-webkit-scrollbar-thumb': { background: '#e2e8f0', borderRadius: '4px' },
        }}
      >
        {isLoading ? (
          <Flex justifyContent="center" pt={8}>
            <Spinner size="sm" color="var(--brand-primary)" />
          </Flex>
        ) : conversations.length === 0 ? (
          <Flex direction="column" alignItems="center" pt={10} gap={1}>
            <Text fontSize="xs" fontWeight="600" color="gray.500">No conversations yet</Text>
            <Text fontSize="xs" color="gray.400">Click New to get started</Text>
          </Flex>
        ) : (
          conversations.map((conv) => (
            <ConversationItem
              key={conv.id}
              conversation={conv}
              isSelected={selectedId === conv.id}
              onSelect={() => onSelect(conv.id)}
            />
          ))
        )}
      </VStack>
    </Box>
  );
};
